module.exports = __webpack_public_path__ + "img/jameson-bottle-age-mobile.13985440.png";